import React from "react";

import echarts from "echarts";
import ReactEcharts from "echarts-for-react";

import { message, Cascader } from "antd";

import API from "@/apis";
import { Link, Switch, Route } from "react-router-dom";

import { SessionStore, LocaleStore, RouterStore } from "@/stores";
import { inject, observer } from "mobx-react";
import "./index.less";
import MyIcon from "@/components/MyIcon";
import MyChart from "@/components/MyChart";
import {
  powerUnit2object,
  timestampFormat,
  TimeChartType,
  HourMap,
  DayMap,
  timeUnix,
  startTime,
} from "@/utils";
import { dashboard } from "@/config.json";
import _ from "lodash";
import locale from "antd/lib/date-picker/locale/en_US";

const infoUrl = {
  EN: "https://support.mempool.com/hc/en-us/articles/360022655033-Why-does-the-Hashrate-fluctuate-",
  ZH: "https://support.mempool.com/hc/zh-cn/articles/360022655033-%E7%9F%BF%E6%9C%BA%E7%AE%97%E5%8A%9B%E4%B8%BA%E4%BB%80%E4%B9%88%E4%BC%9A%E5%87%BA%E7%8E%B0%E6%B3%A2%E5%8A%A8-",
};

interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
}

@inject("session", "locale", "router")
@observer
class ChartLists extends React.Component<Props, any> {
  power: any;
  constructor(props) {
    super(props);
  }
  state = {
    powerSelected: ["hour", "0"],
    minerSelected: ["hour", "0"],
    incomeSelected: ["day", "1"],
  } as any;
  componentDidMount() {
    this.getPowerChart();
    this.getMinerChart();
    this.getEarnChart();
  }

  getPowerChart = () => {
    const { powerSelected } = this.state;
    const { session } = this.props;
    let type = powerSelected[0];
    let current = HourMap[powerSelected[1]];
    let end = timeUnix();
    let start = current.value == 0 ? "" : startTime(current.value, end, current.type);
    session.getPowerGraphic(type, start, end, 1);
  };
  getMinerChart = () => {
    const { minerSelected } = this.state;
    const { session } = this.props;
    let type = minerSelected[0];
    let current = HourMap[minerSelected[1]];
    let end = timeUnix();
    let start = current.value == 0 ? "" : startTime(current.value, end, current.type);
    console.log("======test", minerSelected[1], current, start);
    session.getMinerGraphic(type, start, end, 1);
  };
  getEarnChart = () => {
    const { incomeSelected } = this.state;
    const { session } = this.props;
    let type = incomeSelected[0];
    let current = DayMap[incomeSelected[1]];
    let end = timeUnix();
    let start = current.value == 0 ? "" : startTime(current.value, end, current.type);
    session.getEarnGraphic(type, start, end, 1);
  };

  changePowerSelected = (val) => {
    this.setState(
      {
        powerSelected: val,
      },
      () => this.getPowerChart()
    );
  };

  changeMinerSelected = (val) => {
    this.setState(
      {
        minerSelected: val,
      },
      () => this.getMinerChart()
    );
  };

  changeIncomeSelected = (val) => {
    this.setState(
      {
        incomeSelected: val,
      },
      () => this.getEarnChart()
    );
  };

  render() {
    const { locale } = this.props;
    const { powerChartData, minerChartData, earnChartData } = this.props.session;

    const CascaderOptions = [
      {
        label: locale.get("IndexCharts.PerHour"),
        value: TimeChartType.hour,
        children: [
          {
            label: locale.get(HourMap[0].lable as any),
            value: "0",
          },
          {
            label: locale.get(HourMap[1].lable as any),
            value: "1",
          },
          {
            label: locale.get(HourMap[2].lable as any),
            value: "2",
          },
        ],
      },
      {
        label: locale.get("IndexCharts.PerDay"),
        value: TimeChartType.day,
        children: [
          {
            label: locale.get(HourMap[2].lable as any),
            value: "2",
          },
          {
            label: locale.get(HourMap[3].lable as any),
            value: "3",
          },
          {
            label: locale.get(HourMap[4].lable as any),
            value: "4",
          },
          {
            label: locale.get(HourMap[5].lable as any),
            value: "5",
          },
          {
            label: locale.get(HourMap[6].lable as any),
            value: "6",
          },
        ],
      },
    ];
    const CascaderOptionsIncome = [
      {
        label: locale.get("IndexCharts.PerDay"),
        value: TimeChartType.day,
        children: [
          {
            label: locale.get(DayMap[1].lable as any),
            value: "1",
          },
          {
            label: locale.get(DayMap[2].lable as any),
            value: "2",
          },
          {
            label: locale.get(DayMap[3].lable as any),
            value: "3",
          },
          {
            label: locale.get(DayMap[4].lable as any),
            value: "4",
          },
          {
            label: locale.get(DayMap[5].lable as any),
            value: "5",
          },
        ],
      },
    ];
    const defaultInfoUrl = infoUrl[locale.getLangType] ? infoUrl[locale.getLangType] : infoUrl.EN;
    return (
      <div className="chart-lists">
        <div className="top">
          {/* <MyIcon type="icon-profit" className="icon-size" /> */}
          {locale.get("IndexPage.chartList")}
        </div>
        <div className="subtitle">
          <div>{locale.get("IndexPage.totalHashrates")}</div>
          <div className="sub-right">
            <Cascader
              options={CascaderOptions}
              value={this.state.powerSelected}
              onChange={this.changePowerSelected}
              allowClear={false}
              className="panel-cascader"
            />
          </div>
        </div>
        <div className="daily-charts">
          <MyChart data={powerChartData} type="power" istotal={true} />
        </div>
        <div className="subtitle">
          <div>
            {locale.get("IndexPage.totalMiner")}
            <span className="title-tip">{locale.get("IndexPage.onlineTip")}</span>
          </div>
          <div className="sub-right">
            <Cascader
              options={CascaderOptions}
              value={this.state.minerSelected}
              onChange={this.changeMinerSelected}
              allowClear={false}
              className="panel-cascader"
            />
          </div>
        </div>
        <div className="daily-charts">
          <MyChart data={minerChartData} type="miner" istotal={true} />
        </div>
        <div className="subtitle">
          <div>{locale.get("IndexPage.totalEarn")}</div>
          <div className="sub-right">
            <Cascader
              options={CascaderOptionsIncome}
              value={this.state.incomeSelected}
              onChange={this.changeIncomeSelected}
              allowClear={false}
              className="panel-cascader"
            />
          </div>
        </div>
        <div className="daily-charts">
          <MyChart data={earnChartData} type="earn" istotal={true} />
        </div>
      </div>
    );
  }
}

export default ChartLists as React.ComponentType;
